import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ScholarPage from './components/publication/ScholarPage';
import PublishedBooks from './pages/PublishedBooks';
import People from './pages/People';
import ContactUs from './pages/contactus';
import ProjectDetail from './components/projects/ProjectDetail';
import ProfilePage from './components/people/ProfilePage';
import JoinUsPage from './pages/JoinUs';
import Collaborations from './components/collaboration/Collab';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/publications" element={<ScholarPage />} />
          <Route path="/published-books" element={<PublishedBooks />} />
          <Route path="/people" element={<People />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/joinuspage" element={<JoinUsPage />} />
          <Route path="/collab" element={<Collaborations />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
